import APIService from './class';

class Holidays extends APIService {
  constructor() {
    super( '/holidays' );
  }
}

export default new Holidays();
